import { actionTypes } from "../actions/clippings";

const variable = (state = null, action) => {
  switch (action.type) {
    case actionTypes.FETCH_CLIPPING:
      return action.payload;
    default:
      return state;
  }
};

export default variable;